import { shade, lighten } from 'polished';
import icons from './icons';

export const FONT_FACE = {
    UI: 'Efteling',
    BRAND: 'Alegreya',
    BRAND_BOLD: 'Alegreya',
    BASE: 'OpenSans',
    BASE_FACE: 'Alegreya Sans',
    ICONS: 'icomoon',
};

const palette = {
    // Accent Colors
    purple: '#98224F',
    bordeaux: '#983323',
    red: '#AA182C',
    orange: '#F66D41',
    yellow: '#EEAF30',
    green: '#70A489',
    blue: '#64A0C8',
    black: '#000000',
    white: '#FFFFFF',
    transparent: 'transparent',
    // Shades of grey/brown
    brown: '#4D3928',
    grey: '#A59D95',
    greymiddark: '#737373',
    lightgrey: '#EEEEEE',
    // Shades of taupe
    darktaupe: '#d2ceca',
    taupe: '#D3BF96',
    lighttaupe: '#EDE5D5',
    xlighttaupe: '#F6F2EA',
    xlightgrey: '#FAFAF7',
    // Input border color
    input: '#D2CECA',
};

const font = {
    face: {
        ui: `${FONT_FACE.UI}, serif`,
        brand: `${FONT_FACE.BRAND}, sans-serif`,
        brandBold: `${FONT_FACE.BRAND_BOLD}, sans-serif`,
        base: `${FONT_FACE.BASE}, sans-serif`,
        baseFace: `${FONT_FACE.BASE_FACE}, sans-serif`,
        icon: `${FONT_FACE.ICONS}, sans-serif`,
    },
    copy: {
        default: '16px;',
        medium: '14px',
        small: '12px',
    },
    size: {
        giga: '60px',
        alpha: '48px',
        beta: '32px',
        gamma: '24px',
        delta: '24px',
        epsilon: '21px',
        zeta: '18px',
        milli: '14px',
        micro: '14px',
        nano: '14px',
    },
    heading: {
        h1: '60px',
        h2: '32px',
        h3: '24px',
        h4: '24px',
        h5: '21px',
    },
};

const button = {
    face: font.face.baseFace,
    primary: {
        background: palette.red,
        text: palette.white,
        border: shade(0.15, palette.red),
        hover: shade(0.07, palette.red),
        active: shade(0.09, palette.red),
    },
    secondary: {
        background: palette.white,
        text: palette.red,
        border: palette.lighttaupe,
        hover: palette.xlightgrey,
        active: palette.xlighttapue,
    },
};

export const messagebox = {
    warning: {
        background: lighten(0.35, palette.orange),
        text: palette.orange,
        link: palette.orange,
        border: lighten(0.25, palette.orange),
    },
    fatal: {
        background: lighten(0.55, palette.red),
        text: palette.brown,
        link: palette.red,
        border: lighten(0.45, palette.red),
    },
    tip: {
        background: lighten(0.35, palette.blue),
        text: palette.brown,
        link: palette.blue,
        border: lighten(0.25, palette.blue),
    },
    success: {
        background: lighten(0.35, palette.green),
        text: palette.brown,
        link: palette.green,
        border: lighten(0.25, palette.green),
    },
};

const metrics = {
    radius: '5px',
    spacing: {
        base: '20px',
        quadruple: '80px',
        triple: '60px',
        double: '40px',
        half: '10px',
        quarter: '5px',
    },
};

export const THEME = {
    colors: {
        ...palette,
    },
    font,
    button,
    metrics,
    messagebox,
    icons,
};
